module.exports = __webpack_public_path__ + "static/media/meter_block_blue.833f16d2.png";